import styled from 'styled-components'
import { sizes, colors } from '../../util'

export const Wrapper = styled.div`
  height: 0px;
  top: 2rem;
  padding-top: 90%;
  position: relative;
  margin: 0;
  @media (min-width: ${sizes.medium}) {
    padding-top: 50%;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
`

export const ImageWrapper = styled.div`
  max-width: 50%;
  max-height: 90%;
  position: absolute;
  top: 10px;
  z-index: ${props => props.z};
  a {
    border: none;
  }
  &:hover {
    z-index: 50;
    div {
      transform: translateY(50%) translateX(-3rem) scaleY(1);
      p {
        opacity: 1;
      }
    }
  }
`
export const Caption = styled.div`
  display: ${props => (props.flex ? 'flex' : 'block')};
  align-items: center;
  transition: 0.25s;
  width: ${props => (props.flex ? 'auto' : '100%')};
  margin: 0;
  padding: 0.5rem 0.5rem;
  background: ${colors.white};
  border: 2px solid ${props => props.theme.color};
  bottom: 50%;
  position: absolute;
  transform-origin: top center;
  transform: translateY(50%) translateX(-3rem) scale(0);
  section {
    margin: 0 0.5rem;
    svg,
    img,
    svg path,
    svg polygon,
    svg polyline {
      transition: 0.25s;
      fill: ${props => props.theme.color} !important;
    }
  }
  &:hover {
    cursor: pointer;
    section {
      opacity: 0.5;
    }
  }
`
export const CaptionItem = styled.p`
  opacity 0;
  transition: .25s .125s;
  color: ${props => props.theme.color};
  font-weight: ${props => (props.bold ? '800' : '400')};
  text-transform: ${props => (props.caps ? 'uppercase' : '')};
  font-style: ${props => (props.italic ? 'italic' : 'normal')};
  margin: .5rem 0;
`
export const Refresh = styled.button`
  color: ${props => props.theme.color};
  text-decoration: underline;
  margin-left: 1.5rem;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
  span {
    text-decoration: underline;
  }
`
export const Wrap = styled.div`
  height: ${props => (props.loading ? '80vh' : 'auto')};
  margin: 4rem 0;
  position: relative;
`

export const CaptionWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 0.5rem 1.5rem;
  background: white;
  transform: translateY(100%);
  transition: 0.33s;
  p {
    margin: 0;
  }
  *:not(:first-child) {
    margin-top: 0.25rem;
  }
`

export const RelativeWrapper = styled.div`
  position: relative;
  overflow: hidden;
  &:hover {
    ${CaptionWrapper} {
      transform: translateY(0%);
    }
  }
`

export const ImageTest = styled.img`
  /* max-height: 400px;
  @media (min-width: ${sizes.medium}) {
    max-height: 600px;
  } */
  /* width: 50vw; */
  pointer-events: none;
  max-height: 80vh;
  width: ${({ ar }) => `calc(80vh * ${ar})`};
  height: 100%;
  object-fit: contain;
  /* max-width: 70vw; */
  /* height: 80vh; */
  /* margin: 0 2rem; */

`

export const Placeholder = styled.div`
  max-height: 80vh;
  width: ${({ ar }) => `calc(80vh * ${ar})`};
  height: 80vh;
  object-fit: contain;
  display: flex;
  align-items: center;
  div {
    width: 100%;
    height: 0;
    padding-bottom: ${({ arp }) => `${arp}%`};
    background: green;
  }
  max-width: 100%;
`

export const PlaceholderWrapper = styled.div`
  opacity: ${props => (props.loading ? 1 : 0)};
  transition: opacity 0.5s;
  height: 100%;
  display: flex;
  align-items: center;
  width: 100%;
  div {
    width: 100%;
    height: 66%;
    background: #eee;
    &:nth-child(even) {
      width: 300%;
      height: 100%;
      margin: 0 3rem;
    }
  }
  position: absolute;
`

export const SliderWrapper = styled.div`
  opacity: ${props => (props.loading ? 0 : 1)};
  transition: opacity 0.5s;
  height: 100%;
  .swiper-wrapper {
    align-items: center;
  }
  .swiper-slide {
    flex-shrink: 0;
    flex-grow: 1;
    /* flex: auto; */
    flex-basis: auto;
    height: 100%;
    width: auto;
    max-width: 66vw;
    @media (max-width: ${sizes.medium}) {
      max-width: 75vw;
    }
  }
  .swiper-button-next {
    background: none;
    &:after {
      color: white;
      font-size: 2rem;
      content: '→';
    }
  }
  .swiper-button-prev {
    background: none;
    &:after {
      color: white;
      font-size: 2rem;
      content: '←';
    }
  }
`
export const Loading = styled.p`
  opacity: ${props => (props.loading ? 1 : 0)};
  transition: opacity 2s;
  position: absolute;
  left: 50%;
  top: 50%;
  height: initial !important;
  min-height: initial !important;
  color: ${props => props.theme.colorText};
  z-index: 2;
`

export const Underline = styled.h3`
  font-weight: 400;
  line-height: 1.2;
  margin: 0;
  width: auto;
  display: inline-block;
  background-image: linear-gradient(
    to right,
    ${props => props.theme.colorText} 0%,
    ${props => props.theme.colorText} 100%
  );
  background-repeat: repeat-x;
  background-position: 0 95%;
  background-size: 100% 1px;

  &:hover {
    opacity: 0.7;
  }
`
